module.exports = __webpack_public_path__ + "img/quitarPromo.075318ed.svg";